import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
// Components
import { Text } from 'src/Components'
// Selectors
import { selectListing } from 'src/store/selectors/listings'

const DataSourceDisclaimer = () => {
  const listing = useSelector(selectListing)

  return (
    <div>
      <Text element='p' variant='neutralCool' variantCount='700'>
        {listing && (
          <FormattedMessage
            id='Footer.copyright.dataSource'
            defaultMessage='{disclaimer}'
            values={{ disclaimer: listing.disclaimer }}
          />
        )}
      </Text>
      <br />
      <Text element='p' variant='neutralCool' variantCount='700'>
        <FormattedMessage
          id='HomeSearch.footer.copyright.dataSource.usage'
          defaultMessage='The information being provided is for consumers’ personal, non-commercial use and may not be used for any purpose other than to identify prospective properties that consumers may be interested in purchasing.'
        />
      </Text>
    </div>
  )
}

export default DataSourceDisclaimer
